// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import JsonExcel from "vue-json-excel";
import FlashMessage from '@smartweb/vue-flash-message';
import LayoutHeader from './components/layout/Header'
import LayoutHeadercomponents from './components/layout/Headercomponents'
import LayoutNavbar from './components/layout/Navbar'
import LayoutNavbarcomponents from './components/layout/Navbarcomponents'
import LayoutFooter from './components/layout/Footer'
import LayoutNavbaremail from './components/layout/Navbaremail'
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
import SvgIcon from '@jamescoyle/vue-icon'
import { mdiAccount } from '@mdi/js'
Vue.use(mdiAccount)
Vue.use(SvgIcon)
Vue.use(VuePdfEmbed)
Vue.component("downloadExcel", JsonExcel);
let Bootstrap = require('bootstrap')
import 'bootstrap/dist/css/bootstrap.css'
import './assets/css/font-awesome.min.css'
import './assets/css/feather.css'
import './assets/css/line-awesome.min.css'
import vuetify from './plugins/vuetify'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
require('./assets/css/style.css');
Vue.config.productionTip = false
Vue.component('layout-header', LayoutHeader);
Vue.component('layout-footer', LayoutFooter);
Vue.component('layout-headercomponents', LayoutHeadercomponents);
Vue.component('layout-navbar', LayoutNavbar);
Vue.component('layout-navbarcomponents', LayoutNavbarcomponents);
Vue.component('layout-navbaremail', LayoutNavbaremail);
Vue.use(FlashMessage);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  vuetify,
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js